export default __webpack_public_path__ + "static/media/5370.99ebb64e.png";